import { motion } from 'framer-motion';
import ButtonLink from '@components/common/Button/ButtonLink';
import { usePageSetup } from '@/hooks/usePageSetup';

export const CookiePolicyPage = () => {
  usePageSetup('Slapukų politika - Finhudas', { scroll: true })

  return (
    <div className="h-full bg-white p-5 pt-8 pb-8 flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="text-2xl font-bold mb-4 text-center"
        >
          SLAPUKŲ POLITIKA
        </motion.h1>
        <div className="space-y-4 text-base text-gray-800">
          <p>MB „Kurohudas", juridinio asmens kodas: 305718356, adresas: Vytauto g. 34-5, LT-92127, Klaipėda, Lietuva, el. p. <a href="mailto:info@finhudas.lt" className="text-blue-600 underline">info@finhudas.lt</a>, naudoja slapukus internetinėje svetainėje <a href="https://www.finhudas.lt/" className="text-blue-600 underline">https://www.finhudas.lt/</a> (toliau – „Svetainė"). Naršydami Svetainėje sutinkate su slapukų naudojimu. Prašome perskaityti žemiau pateikiamą informaciją apie tai, kas yra slapukai ir kaip juos naudojame. Periodiškai mes galime atnaujinti šią Slapukų politiką, todėl prašome peržiūrėti šią informaciją.</p>

          <h2 className="text-lg font-semibold mt-6">Kas yra slapukai?</h2>
          <p>Kad ši svetainė tinkamai veiktų, kartais į Jūsų įrenginį įrašomos mažos duomenų rinkmenos, vadinamos slapukais. Slapukas – tai nedidelis failas, atsiųstas į įrenginį, naudotojui besilankant atitinkamoje interneto svetainėje. Slapukų pagalba interneto svetainė atpažįsta naudotojo įrenginį (pvz., naudotojui kitą kartą apsilankius šioje interneto svetainėje). Slapukų informacija nėra naudojama asmeninei informacijai apie naudotoją rinkti.</p>

          <h2 className="text-lg font-semibold mt-6">Naudojami slapukai</h2>
          
          <h3 className="text-md font-semibold mt-4">Analitiniai</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Pavadinimas</th>
                  <th className="border border-gray-300 p-2 text-left">Aprašymas</th>
                  <th className="border border-gray-300 p-2 text-left">Galiojimo laikas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">_gid</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">1 diena</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_ga</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">2 metai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_ga_*</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">1 metai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_dc_gtm_UA-*</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti paslaugų užklausų skaičių</td>
                  <td className="border border-gray-300 p-2">1 minutė</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">SL_C_*_SID</td>
                  <td className="border border-gray-300 p-2">identifikuoti sesijos ID, priskirtą kiekvienai naujai sesijai</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">SL_C_*_VID</td>
                  <td className="border border-gray-300 p-2">lankytojo ID, kuris priskiriamas kiekvienam naujam lankytojui</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">SL_C_*_KEY</td>
                  <td className="border border-gray-300 p-2">identifikuoti projekto ID (raktą), unikalų kiekvienam projektui, įtrauktam į Smartlook aplinką</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">SL_L_23361dd035530_SID</td>
                  <td className="border border-gray-300 p-2">identifikuoti projekto ID (raktą), sesijos ID ir lankytojo ID</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjSessionUser_*</td>
                  <td className="border border-gray-300 p-2">išsaugoti unikalų lankytojo ID</td>
                  <td className="border border-gray-300 p-2">1 metai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjIncludedInSessionSample</td>
                  <td className="border border-gray-300 p-2">nustatyti, ar naudotojas įtrauktas į duomenų imtį, nustatytą pagal svetainės dienos seanso limitą</td>
                  <td className="border border-gray-300 p-2">30 minučių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjIncludedInPageviewSample</td>
                  <td className="border border-gray-300 p-2">nustatyti, ar naudotojas įtrauktas į duomenų imtį, nustatytą pagal svetainės puslapių peržiūrų limitą</td>
                  <td className="border border-gray-300 p-2">30 minučių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjAbsoluteSessionInProgress</td>
                  <td className="border border-gray-300 p-2">išsaugoti unikalius apsilankymus</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hp2_id</td>
                  <td className="border border-gray-300 p-2">vartotojo elgsenos sekimo slapukas</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hp2_props</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hp5_event_props</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjDonePolls</td>
                  <td className="border border-gray-300 p-2">išsaugoti apklausų būseną</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjMinimizedPolls</td>
                  <td className="border border-gray-300 p-2">išsaugoti apklausų būseną</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_cs_c</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_cs_id</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">13 mėnesių</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">exp_pricing_fall_assignment</td>
                  <td className="border border-gray-300 p-2">išsaugoti A/B testavimo kainodaros ekspermentą</td>
                  <td className="border border-gray-300 p-2">1 minutė</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">in_opt_in_signup_trials_experiment</td>
                  <td className="border border-gray-300 p-2">išsaugoti bandomajo laikotarpio expermentą</td>
                  <td className="border border-gray-300 p-2">1 minutė</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-md font-semibold mt-6">Rinkodaros</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Pavadinimas</th>
                  <th className="border border-gray-300 p-2 text-left">Aprašymas</th>
                  <th className="border border-gray-300 p-2 text-left">Galiojimo laikas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">gclid</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir stebėti konversijas</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_gcl_au</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir stebėti konversijas</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">smartlook_setup_retry_after</td>
                  <td className="border border-gray-300 p-2">rinkti duomenis apie vartotojų elgesį ir sąveiką, siekiant optimizuoti svetainę ir padaryti reklamą svetainėje aktualesnę</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">smartlook_setup_retry_after_reason</td>
                  <td className="border border-gray-300 p-2">rinkti duomenis apie vartotojų elgesį ir sąveiką, siekiant optimizuoti svetainę ir padaryti reklamą svetainėje aktualesnę</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_hjSession_*</td>
                  <td className="border border-gray-300 p-2">teikti funkcijas visuose puslapiuose</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">lastExternalReferrer</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">lastExternalReferrerTime</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_fbp</td>
                  <td className="border border-gray-300 p-2">išsaugoti ir skaičiuoti puslapio peržiūras</td>
                  <td className="border border-gray-300 p-2">3 mėnesiai</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">omnisendSessionID</td>
                  <td className="border border-gray-300 p-2">identifikuoti sesijos ID, priskirtą kiekvienai naujai sesijai</td>
                  <td className="border border-gray-300 p-2">1 diena</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">soundestID</td>
                  <td className="border border-gray-300 p-2">nustatyti, ar lankytojas svetainėje yra naujas, ar lankytojas lankėsi anksčiau</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">referrer</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">utm_source</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">utm_medium</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">utm_campaign</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">utm_content</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">utm_term</td>
                  <td className="border border-gray-300 p-2">identifikuoti apsilankymo kilmę</td>
                  <td className="border border-gray-300 p-2">sesija</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-md font-semibold mt-6">Būtini</h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 text-left">Pavadinimas</th>
                  <th className="border border-gray-300 p-2 text-left">Aprašymas</th>
                  <th className="border border-gray-300 p-2 text-left">Galiojimo laikas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">dialCode</td>
                  <td className="border border-gray-300 p-2">svetainės veikimui</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">locale</td>
                  <td className="border border-gray-300 p-2">svetainės veikimui</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">phoneNumberLocale</td>
                  <td className="border border-gray-300 p-2">svetainės veikimui</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">landingPageType</td>
                  <td className="border border-gray-300 p-2">svetainės veikimui</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-2">_pf*</td>
                  <td className="border border-gray-300 p-2">svetainės veikimui</td>
                  <td className="border border-gray-300 p-2">neribojamas</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-lg font-semibold mt-6">Informavimas apie slapukų naudojimą</h2>
          <p>Apsilankant internetinėje svetainėje pirmą kartą Jūs esate informuojami, jog svetainėje naudojami slapukai. Iškylančiame lange Jūs turite galimybę iš karto susipažinti su slapukų politika paspaudę atitinkamą nuorodą.</p>

          <h2 className="text-lg font-semibold mt-6">Slapukų kontroliavimas</h2>
          <p>Slapukus galite valdyti ir (arba) ištrinti pagal savo pageidavimus. Galite ištrinti visus jūsų kompiuteryje jau esančius slapukus, o daugumoje naršyklių galite nustatyti, kad slapukai nebūtų įrašomi. Tačiau tokiu atveju kai kurios funkcijos gali neveikti. Atsisakyti galite tik tų slapukų, kurie nėra būtini. Kai kurie slapukai būtini tam, kad galėtumėte naudotis šia svetaine. Be šių slapukų neveiks tam tikros funkcijos. Atsisakyti „Google Analytics" slapukų galite vadovaujantis nuorodomis šioje interneto svetainėje: <a href="https://tools.google.com/dlpage/gaoptout" className="text-blue-600 underline">https://tools.google.com/dlpage/gaoptout</a>.</p>

          <h2 className="text-lg font-semibold mt-6">Slapukų naudojimo nustatymai interneto naršyklėse:</h2>
          <ul className="list-disc ml-6">
            <li><strong>Firefox:</strong> <a href="https://support.mozilla.org/lt/kb/Slapuk%C5%B3%20valdymas?redirectlocale=en-US&redirectslug=Cookies" className="text-blue-600 underline">https://support.mozilla.org/lt/kb/Slapuk%C5%B3%20valdymas</a></li>
            <li><strong>Chrome:</strong> <a href="https://support.google.com/chrome/answer/95647?hl=lt" className="text-blue-600 underline">https://support.google.com/chrome/answer/95647?hl=lt</a></li>
            <li><strong>Internet Explorer:</strong> <a href="https://support.microsoft.com/lt-lt/help/17442/windows-internet-explorer-delete-manage-cookies" className="text-blue-600 underline">https://support.microsoft.com/lt-lt/help/17442/windows-internet-explorer-delete-manage-cookies</a></li>
          </ul>

          <p className="mt-4">Daugiau informacijos apie slapukus: <a href="http://www.allaboutcookies.org" className="text-blue-600 underline">http://www.allaboutcookies.org</a></p>
        </div>
      </div>
      <div className="mt-8">
        <ButtonLink to="/profile">
          Grįžti atgal
        </ButtonLink>
      </div>
    </div>
  );
}

export default CookiePolicyPage;
